export function getPathExtension(path: string) {
    return path.slice((path.lastIndexOf(".") - 1 >>> 0) + 1);
}

export function urlToFilename(url: string): string | undefined {
    if (url.indexOf('/') > -1) {
        return url.substring(url.lastIndexOf('/') + 1);
    }
    return url;
}